import React from 'react';

import Sharebar from './Sharebar'

class Header extends React.Component {
    
    render(){
    
       return (
         <React.Fragment>
          <div className="stuffHeader-container">
             {/* eslint-disable-next-line */}
             <a target="_blank" href="https://www.stuff.co.nz/" className="stuffHeader-container__logo" rel="noopener noreferrer"></a>
              <Sharebar />
            <div className="stuffHeader-container--rainbow"></div>
          </div>
         
          </React.Fragment>
       );
    }
}

export default Header;